/**
 * Created by eliasmj on 29/10/2014.
 */
angular.module('qkr').directive('ellipsisTooltip', () => ({
        restrict: 'A',
        template: require('../templates/directives_templates/ellipsis_tooltip.html'),

        scope: {
          textTip: '@'
        }

    }));



// WEBPACK FOOTER //
// ./src/directives/ellipsis_tooltip.js